import React, { FC } from 'react'

interface ModalContentProps {
  children: React.ReactNode
  title?: string
  onClose?: () => void
  className?: string
}

/**
 * 統合されたモーダルコンテンツコンポーネント
 * タイトルが指定されればヘッダー付き、なければシンプルなコンテンツのみ
 */
const ModalContent: FC<ModalContentProps> = ({
  children,
  title,
  onClose,
  className = ''
}) => {
  return (
    <div
      className={`bg-white max-h-[85vh] rounded-md max-w-[90vw] overflow-y-auto overscroll-none ${className}`}
    >
      {title && (
        <div className="relative bg-main-green">
          <p className="py-4 text-white text-center text-lg sm:text-2xl font-bold">
            {title}
          </p>
          {onClose && (
            <button
              onClick={onClose}
              className="absolute top-0 right-0 mt-3 sm:mt-4 mr-4 text-white text-3xl font-bold hover:opacity-80"
            >
              ×
            </button>
          )}
        </div>
      )}
      <div className={title ? 'max-h-[calc(85vh-100px)] overflow-y-auto' : ''}>
        {children}
      </div>
    </div>
  )
}

export default ModalContent